/*
=========================================
DREAMS SIZE CALCULATOR
Parte 1 de 5
=========================================
*/

document.addEventListener("DOMContentLoaded", function () {

    /* ================================
       ELEMENTOS
    ================================ */

    const drawer = document.getElementById("dreams-calculator-drawer");
    const overlay = document.getElementById("dreams-calculator-overlay");

    const openButton = document.getElementById("dreams-open-calculator");
    const closeButton = document.getElementById("dreams-close-calculator");

    const progressFill = document.getElementById("dreams-progress-fill");
    const progressText = document.getElementById("dreams-progress-text");

    const heightInput = document.getElementById("dreams-height");
    const weightInput = document.getElementById("dreams-weight");

    const resultSize = document.getElementById("dreams-result-size");
    const resultDescription = document.getElementById("dreams-result-description");

    const selectSizeButton = document.getElementById("dreams-select-size");

    const steps = document.querySelectorAll(".dreams-step");

    const genderButtons = document.querySelectorAll(".dreams-option");

    const fitButtons = document.querySelectorAll(".dreams-fit");

    const nextButtons = document.querySelectorAll(".dreams-next");



    /* ================================
       VARIABLES
    ================================ */

    let currentStep = 1;

    const answers = {

        gender: null,

        height: null,

        weight: null,

        fit: null,

        size: null

    };



    /* ================================
       ABRIR DRAWER
    ================================ */

    function openCalculator(){

        drawer.classList.add("active");

        overlay.classList.add("active");

    }



    /* ================================
       CERRAR DRAWER
    ================================ */

    function closeCalculator(){

        drawer.classList.remove("active");

        overlay.classList.remove("active");

    }



    /* ================================
       EVENTOS DRAWER
    ================================ */

    if(openButton){

        openButton.addEventListener("click",openCalculator);

    }

    if(closeButton){

        closeButton.addEventListener("click",closeCalculator);

    }

    if(overlay){

        overlay.addEventListener("click",closeCalculator);

    }



    /* ================================
       CAMBIAR PASOS
    ================================ */

    function showStep(step){

        currentStep = step;

        steps.forEach(function(section){

            section.classList.remove("active");

        });

        const activeStep = document.querySelector(

            '.dreams-step[data-step="'+step+'"]'

        );

        if(activeStep){

            activeStep.classList.add("active");

        }

        progressFill.style.width = (step * 20) + "%";

        progressText.textContent =

            "Paso " + Math.min(step,5) + " de 5";

    }



    showStep(1);
        /* ================================
       PASO 1 - GÉNERO
    ================================ */

    genderButtons.forEach(function(button){

        button.addEventListener("click",function(){

            genderButtons.forEach(function(btn){

                btn.classList.remove("selected");

            });

            this.classList.add("selected");

            answers.gender = this.dataset.gender;

            showStep(2);

        });

    });



    /* ================================
       BOTONES SIGUIENTE
    ================================ */

    nextButtons.forEach(function(button){

        button.addEventListener("click",function(){

            if(currentStep === 2){

                answers.height = parseInt(heightInput.value);

                showStep(3);

                return;

            }

            if(currentStep === 3){

                answers.weight = parseInt(weightInput.value);

                showStep(4);

                return;

            }

        });

    });



    /* ================================
       PASO 4 - FIT
    ================================ */

    fitButtons.forEach(function(button){

        button.addEventListener("click",function(){

            fitButtons.forEach(function(btn){

                btn.classList.remove("selected");

            });

            this.classList.add("selected");

            answers.fit = this.dataset.fit;

            calculateRecommendation();

        });

    });
        /* ================================
       CALCULAR TALLA
    ================================ */

    function calculateRecommendation(){

        let scoreS = 0;
        let scoreM = 0;
        let scoreL = 0;

        /* =====================
           ALTURA
        ===================== */

        if(answers.height <= 165){

            scoreS += 4;

        }else if(answers.height <= 178){

            scoreM += 4;

        }else{

            scoreL += 4;

        }

        /* =====================
           PESO
        ===================== */

        if(answers.weight <= 60){

            scoreS += 4;

        }else if(answers.weight <= 78){

            scoreM += 4;

        }else{

            scoreL += 4;

        }

        /* =====================
           FIT
        ===================== */

        switch(answers.fit){

            case "slim":

                scoreS += 2;

            break;

            case "regular":

                scoreM += 2;

            break;

            case "oversize":

                scoreL += 2;

            break;

        }

        /* =====================
           GÉNERO
        ===================== */

        if(answers.gender === "female"){

            scoreS += 1;

        }else{

            scoreM += 1;

        }

        /* =====================
           DECISIÓN
        ===================== */

        let size = "M";

        if(scoreS >= scoreM && scoreS >= scoreL){

            size = "S";

        }

        if(scoreM >= scoreS && scoreM >= scoreL){

            size = "M";

        }

        if(scoreL >= scoreS && scoreL >= scoreM){

            size = "L";

        }

        answers.size = size;

        showResult();

    }



    /* ================================
       MOSTRAR RESULTADO
    ================================ */

    function showResult(){

        resultSize.textContent = answers.size;

        if(answers.size === "S"){

            resultDescription.textContent =
            "Te recomendamos la talla S. Según tu estatura, peso y el fit que elegiste, será la que mejor te quede.";

        }

        if(answers.size === "M"){

            resultDescription.textContent =
            "Te recomendamos la talla M. Es la talla más equilibrada para lograr el fit que seleccionaste.";

        }

        if(answers.size === "L"){

            resultDescription.textContent =
            "Te recomendamos la talla L para mantener la caída y el estilo oversize de la prenda.";

        }

        showStep(5);

    }
        /* ==========================================
       SHOPIFY
       SELECCIONAR VARIANTE
    ========================================== */

    function selectVariant(size){

        const variantSelect = document.querySelector('form[action*="/cart/add"] select[name="id"]');

        if(!variantSelect){

            console.log("No se encontró el selector de variantes.");

            return;

        }

        const options = Array.from(variantSelect.options);

        let found = false;

        options.forEach(function(option){

            if(option.text.toUpperCase().includes(size)){

                variantSelect.value = option.value;

                found = true;

            }

        });

        if(found){

            variantSelect.dispatchEvent(

                new Event("change",{

                    bubbles:true

                })

            );

        }

    }



    /* ==========================================
       BOTÓN
       SELECCIONAR TALLA
    ========================================== */

    if(selectSizeButton){

        selectSizeButton.addEventListener("click",function(){

            if(!answers.size){

                return;

            }

            selectVariant(answers.size);

            closeCalculator();

        });

    }



    /* ==========================================
       REINICIAR
    ========================================== */

    function resetCalculator(){

        answers.gender = null;

        answers.height = null;

        answers.weight = null;

        answers.fit = null;

        answers.size = null;

        genderButtons.forEach(function(btn){

            btn.classList.remove("selected");

        });

        fitButtons.forEach(function(btn){

            btn.classList.remove("selected");

        });

        heightInput.selectedIndex = 0;

        weightInput.selectedIndex = 0;

        showStep(1);

    }



    overlay.addEventListener("click",function(){

        resetCalculator();

    });



    closeButton.addEventListener("click",function(){

        resetCalculator();

    });
        /* ==========================================
       INICIALIZACIÓN
    ========================================== */

    // Reiniciar cuando se abra nuevamente
    if(openButton){

        openButton.addEventListener("click",function(){

            resetCalculator();

        });

    }

    /* ==========================================
       VALIDACIONES
    ========================================== */

    if(!drawer){

        console.warn("Dreams Calculator: Drawer no encontrado.");

    }

    if(!overlay){

        console.warn("Dreams Calculator: Overlay no encontrado.");

    }

    if(!progressFill){

        console.warn("Dreams Calculator: Barra de progreso no encontrada.");

    }

    /* ==========================================
       DEBUG
    ========================================== */

    console.log("✅ DREAMS Size Calculator cargada correctamente.");

});